export default __webpack_public_path__ + "static/media/watching.9c894f1e.svg";